import routerOptions0 from "/opt/atlassian/pipelines/agent/build/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@20.11.7_db0@0.3.2_encoding@0.1.13_eslint@8.56.0_4yg3jkbcnoqhgmzyq4k3qtueuy/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}